<template>
  <popup
    :close-action="closeActionClicked"
    class="explain-variables-popup"
    :title="'למה יתרת המשתנות זה הכסף שנשאר להוציא?'"
    :buttons="[{ title: 'חזרה לתזרים', variant: 'secondary', action: closeActionClicked }]">
    <template v-slot:content>
      <div class="explanation-text">
        <div class="bold">שימו ❤️ יתרת המשתנות לא תלויה בכמות הכסף שיש בעו״ש!</div>
        <div>עמידה ביתרת המשתנות עוזרת לשמור על תזרים חיובי 💪</div>
        <div class="subtitle">איך מחושבת יתרת ההוצאות המשתנות?</div>
        <div>אחרי שהמערכת הורידה מההכנסות הצפויות את כל ההוצאות הקבועות והחוזרות, הסכום שנשאר, הוא בעצם יתרת ההוצאות המשתנות.</div>
        <div class="subtitle">זה המספר הכי חשוב. אם נעמוד בו, נסיים את החודש בתזרים חיובי!</div>
        <div>לסיים בתזרים חיובי אומר שבסוף החודש</div>
        <div class="bold">נשאר כסף שלא הוצאנו,</div>
        <div class="bold">כלומר יותר כסף בעו״ש 💪</div>
      </div>
      <thumbs class="thumbs" v-on:thumbsup="thumbsUp" v-on:thumbsdown="thumbsDown" question-text="האם זה עזר לך להבין?"></thumbs>
    </template>
  </popup>
</template>

<script>
import BaseUI from 'base-ui';
import Segment from '../../../../../../../../Segment';
import Thumbs from '../../../../../../../../base-components/Thumbs.vue';

export default {
  name: 'ExplainVariablesPopup',
  components: {
    Thumbs,
    Popup: BaseUI.Popup,
  },
  async created() {
    Segment.trackUserInteraction('ExplainVariablesPopupOpened');
  },
  methods: {
    closeActionClicked() {
      Segment.trackUserInteraction('ExplainVariablesPopupClosed');
      this.$emit('close');
    },
    thumbsUp() {
      Segment.trackUserInteraction('ExplainVariablesPopup_ThumbsUp');
    },
    thumbsDown() {
      Segment.trackUserInteraction('ExplainVariablesPopup_ThumbsDown');
    },
  },
};

</script>

<style scoped lang="scss">

  @import "~base-ui/src/scss/riseup-colors";

  .explain-variables-popup {
    .explanation-text {
      font-size: 16px;
      line-height: 1.5;
      .subtitle {
        margin-top: 24px;
        font-weight: bold;
      }
      .bold {
        font-weight: bold;
      }
    }

    .thumbs {
      margin-top: 40px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/ExplainVariablesPopup.vue